import { useMemo } from 'react'
import Select, { ControlProps, SingleValue } from 'react-select'
import { BoltIcon } from '@heroicons/react/24/outline'
import { useTranslation } from 'libs/i18n'

import Control from '../Sort/Control'
import { menuClassNames } from '../classNames'
import { WithClassName } from 'shared/types/general.types'
import { cn } from 'utils/style'

type ActionOption = {
	value: string
	label: string
	isDisabled?: boolean
}

type ActionsSelectVariant = 'header' | 'filters'

type ActionsSelectProps = WithClassName<{
	options: ActionOption[]
	variant?: ActionsSelectVariant
	onChange: (action: string) => void
}>

const createActionsControl = (compact: boolean) =>
	function ActionsControl(props: ControlProps<ActionOption, false>) {
		const { t } = useTranslation()

		return <Control {...props} compact={compact} icon={<BoltIcon />} label={t('Actions')} />
	}

export const ActionsSelect = ({
	options,
	className,
	variant = 'header',
	onChange
}: ActionsSelectProps) => {
	const { t } = useTranslation()
	const isFilters = variant === 'filters'
	const ActionsControl = useMemo(() => createActionsControl(!isFilters), [isFilters])

	return (
		<Select
			className={cn('relative', className)}
			classNames={{
				...menuClassNames,
				control: (state) => cn(menuClassNames.control?.(state), isFilters && '!h-10'),
				menu: (state) => cn(menuClassNames.menu?.(state), isFilters && '!left-0 !right-auto')
			}}
			options={options}
			value={null}
			isSearchable={false}
			blurInputOnSelect
			aria-label={t('Actions')}
			components={{ Control: ActionsControl }}
			onChange={(option: SingleValue<ActionOption>) => option && onChange(option.value)}
		/>
	)
}
